import * as React from "react";
import Box from "@mui/material/Box";
import SliderImage from "./SliderImage";
import OurMission from "./OurMission";
import Future from "./Future";
import News from "./News";


export default function Landing() {
  return (
    
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          // pt: { xs: 0, sm: 0 },
          // pb: { xs: 8, sm: 12 },
        }}
      >
        <SliderImage/>
        <OurMission/>
        <Future/>
        {/* <News/> */}
      </Box>
    
  );
}
